export default __webpack_public_path__ + "static/media/GLVR.7627cd58.png";